// extracted by mini-css-extract-plugin
export default {"wrap":"Compare_wrap__nuqw2","particles":"Compare_particles__buqPT","map":"Compare_map__-oUsH","slides":"Compare_slides__tEqXP"};